// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

const nullableNumber = anyOf(number, nullValidation);
const nullableString = anyOf(string, nullValidation);

const backfillCount = objectOf({
  window: string,
  count: nullableNumber,
  precision: nullableString,
});

export const isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillCountsResult = objectOf({
  orders: arrayOf(backfillCount),
  customers: arrayOf(backfillCount),
});
